import React from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import axios from 'axios';
import { Worker, Viewer } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import { pdfjs } from 'react-pdf';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';

import Loading from '../Components/Loading';
import Logo from '../Components/Logo';

import styles from '../styles/FileViewer.module.css'
import stylesDM from '../styles/DynamicModal.module.css';
import stylesLogo from '../styles/Logo.module.css';

pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js`;

const FileViewer = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const { id } = useParams();
    const [fileBlob, setFileBlob] = React.useState(null);
    const [loading, setLoading] = React.useState(true);
    const [warning, setWarning] = React.useState('');
    const defaultLayoutPluginInstance = defaultLayoutPlugin();

    document.title = `Просмотр файла — Журнал «Поток»`;

    const token = localStorage.getItem('token');

    React.useEffect(() => {
        axios.get(`/api/view-file/${id}`, {
            responseType: 'blob', // бинарные данные (PDF)
            headers: {
                Authorization: `Bearer ${token}`,
            },
        })
        .then((response) => {
            const blob = new Blob([response.data], { type: 'application/pdf' });
            setFileBlob(URL.createObjectURL(blob)); // Создаем URL для просмотра PDF
        })
        .catch(async (error) => {
            console.error('Ошибка загрузки PDF:', error);

            let errorMessage = 'Неизвестная ошибка';
        
            if (error.response?.data instanceof Blob) {
                try {
                    const text = await error.response.data.text(); // читаем blob как текст
                    const json = JSON.parse(text); // пробуем парсить как JSON
                    errorMessage = json.message || error.message;
                } catch {
                    errorMessage = error.message;
                }
            } else {
                errorMessage = error.response?.data?.message || error.message;
            }
        
            setWarning(`Невозможно отобразить файл на предпросмотр: ${errorMessage}`);
        })
        .finally(() => {
            setLoading(false);
        });
    }, [id]);

    const handleBack = () => {
        const currentPath = location.pathname;
        const previousPath = window.history.state && window.history.state.idx > 0 ? window.history.state.idx - 1 : null;

        if (previousPath !== null && previousPath !== currentPath) {
            navigate(-1);
        } else {
            navigate("/home");
        }
    };

    return (
    <>
        <a style={{zIndex: '9999'}} className={stylesLogo.widthLimitation}><Logo to='/' position='fixed' /></a>
        <div className='mainContainer'>
            <div className={styles.fileViewer}>
                <div className={styles.header}>
                    <span>
                        <h1>Просмотр файла</h1>
                    </span>
                    <svg onClick={handleBack} viewBox="0 0 24 24" fill="none">
                        <path fillRule="evenodd" clipRule="evenodd" d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z" fill="#000000"/>
                    </svg>
                </div>
                <div className={styles.main}>
                    {loading ? (
                        <Loading />
                    ) : warning ? (
                        <div style={{display: 'flex', justifyContent: 'center'}}><a className={stylesDM.statusPanel} style={{maxWidth: '400px'}}><img src='/img/icons/warning-icon.svg' alt='Предупреждение' />{warning}</a></div>
                    ) : fileBlob ? (
                        <Worker workerUrl={pdfjs.GlobalWorkerOptions.workerSrc}>
                            <Viewer fileUrl={fileBlob} plugins={[defaultLayoutPluginInstance]} />
                        </Worker>
                    ) : (
                        <a>Не удалось загрузить компонент</a>
                    )}
                </div>
            </div>
        </div>
    </>
    );
};

export default FileViewer;
